export class NotBoundException extends Error {
  constructor(public readonly binding: string) {
    super(`${binding} is not bound in the container. Did you forget to bind it?`);
  }
}
